import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import APP_CONFIG from '../../app/app.config';

import * as $ from "jquery";

/*
  Generated class for the AccountProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AccountProvider {
    constructor(public http: HttpClient) {
        console.log("Hello AccountProvider Provider");
    }


    /**
     *
     */
    loadProfile() {
        return this.http.get(`${APP_CONFIG.baseURL}/account/profile`);
    }


    /**
     *
     */
    loadOptions() {
        return this.http.get(`${APP_CONFIG.baseURL}/common/options`);
    }

    /**
     *
     * @param body
     */
    login(body) {
        return this.http.post(`${APP_CONFIG.baseURL}/account/login`, body);
    }


    /**
     *
     * @param body
     */
    updateProfile(body) {
        return this.http.post(`${APP_CONFIG.baseURL}/account/updateprofile`, body);
    }


    /**
     *
     * @param body
     */
    register(body) {
        return this.http.post(`${APP_CONFIG.baseURL}/account/register`, body);
    }

    /**
     *
     * @param body
     */
    forgot(body) {
        return this.http.post(`${APP_CONFIG.baseURL}/account/forgot`, body);
    }

    /**
     *
     */
    topTen(params = {}) {
        params = $.param(params);
        return this.http.get(`${APP_CONFIG.baseURL}/posts/list?${params}`);
    }

    /**
     *
     */
    sound(params = {}) {
        params = $.param(params);
        return this.http.get(`${APP_CONFIG.baseURL}/account/sound?${params}`);
    }
}



// WEBPACK FOOTER //
// ./src/providers/account/account.ts